<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Flagged match</template>

    <Sheet.Body class="pt-[25px]">
      <FlaggedMatchBody :infringement="infringement" />

      <Button
        variant="primary"
        size="lg"
        class="mt-4 mb-[env(safe-area-inset-bottom)] w-full"
        @click="handleCreate"
      >
        Create report
      </Button>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import FlaggedMatchBody from './FlaggedMatchBody.vue'
import { useFlaggedMatch, type FlaggedInfringement } from './useFlaggedMatch'

const props = defineProps<{ infringement: FlaggedInfringement }>()

const { close } = useSheet()
const { handleCreate } = useFlaggedMatch(props.infringement)
</script>
